import React from 'react';
import { Helmet } from 'react-helmet';
import { scroller } from 'react-scroll';
import { withTranslation } from 'react-i18next';
import SickNoteArea from './SickNote/SickNoteArea';
import { getFAQSchema } from './SickNote/faqData';

class SickNoteLanding extends React.Component {
  componentDidMount() {
    this._scrollToTop();
  }

  _scrollToTop() {
    scroller.scrollTo('sicknote', {
      duration: 800,
      smooth: true,
      offset: -100
    });
  }

  render() {
    const { t } = this.props;
    // Get the FAQ schema for structured data
    const faqSchema = getFAQSchema();

    return (
      <>
        <Helmet>
          <title>{t('Request a sick note (certificate for time off work or school due to illness) online.')} | Richmond In-Store Medical Clinic</title>
          <link rel="canonical" href="https://instoremed.com/sicknote" />
          <meta
            name="description"
            content={t("Need a doctor's note for work or school? Get a legally valid sick note online for $50. Fast, secure, and doctor-issued within 1 business day. PIPA compliant.")}
          />
          <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        </Helmet>

        <section id="sicknote" className="py-2">
          <div className="container">
            <h1 className="center p-1">{t('Request a sick note (certificate for time off work or school due to illness) online.')}</h1>
            <div className="bottom-line"></div>
            <p className="center py-1">
              {t("At the Richmond In-Store Medical Clinic, we offer a convenient online service for obtaining doctor's notes for work or school absences. Typically provided within 1 business day.")}
            </p>
          </div>
        </section>

        <SickNoteArea />
      </>
    );
  }
}

export default withTranslation()(SickNoteLanding);
